// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).mfRemoteUrls = {
    platformAppMfRemoteTemplate: 'http://localhost:8082',
};

import('./bootstrap');
